import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetFrameBySkuInput } from './GetFrameBySkuInput';
import { GetFrameBySkuOutput } from './GetFrameBySkuOutput';

export class GetFrameBySkuService extends HttpServiceBase {

  handle = (input: GetFrameBySkuInput): Promise<Result<GetFrameBySkuOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<GetFrameBySkuOutput>>(`${this.baseUrlSislogApi}/v2/frame${parameters}`);
    return promise;
  }
}